const baseurl = "https://api-dev.fusionkitchen.co.uk";
const keyurl = " https://order-onedb-fmb-backend.fusiontesting.co.uk/paymentCustom";
const keyurl2 = "https://order-onedb-fmb-backend.fusiontesting.co.uk/getClientApiKey";
const keyurl3 = "https://order-onedb-fmb-backend.fusiontesting.co.uk/getclientstripe";
const local  = "http://localhost:8080";
const liveurl = "https://api.fmb.eposapi.co.uk";
// https://order-onedb-fmb-backend.fusiontesting.co.uk/

//Live
export const POSTPAYMENTINTENT = keyurl;
export const GETCLIENTKEY = keyurl2;
export const GETCLIENTSTRIPE = keyurl3;
export const INSERTPAYMENTAMOUNT = keyurl;
//dev
// export const POSTPAYMENTINTENT = keyurl;
// export const GETCLIENTKEY = keyurl;
// export const INSERTPAYMENTAMOUNT = keyurl;
//Local
// export const POSTPAYMENTINTENT = keyurl;
// export const GETCLIENTKEY = keyurl;
// export const INSERTPAYMENTAMOUNT = keyurl;